export { default as CoverPage } from './CoverPage'
export { default as ExecutiveSummary } from './ExecutiveSummary'
export { default as IntroLetter } from './IntroLetter'
export { default as AboutUs } from './AboutUs'
export { default as ScopeOfServices } from './ScopeOfServices'
export { default as ServiceArea } from './ServiceArea'
export { default as StartupPlan } from './StartupPlan'
export { default as ProjectDetails } from './ProjectDetails'
export { default as NotesDetails } from './NotesDetails'
export { default as TermsConditions } from './TermsConditions'

const MODULE_COMPONENTS = {
  cover: require('./CoverPage').default,
  executiveSummary: require('./ExecutiveSummary').default,
  intro: require('./IntroLetter').default,
  about: require('./AboutUs').default,
  scope: require('./ScopeOfServices').default,
  serviceArea: require('./ServiceArea').default,
  startup: require('./StartupPlan').default,
  project: require('./ProjectDetails').default,
  notes: require('./NotesDetails').default,
  terms: require('./TermsConditions').default,
}

export default MODULE_COMPONENTS
